import React from "react";
import { TemplateStyled, PreviewTemplateWrapper } from "../Templates/styled";
//import { MailBuilder } from "mail-builder-package";
import CardTemplateActions from "./CardTemplateActions/CardTemplateActions";
import { observable, action } from "mobx";
import { TemplateModel } from "../../../stores/TemplateModel";
import { observer } from "mobx-react";

interface Props {
  template: TemplateModel;
}

@observer
class Template extends React.PureComponent<Props, any> {
  BASE_URL =
    process.env.NODE_ENV === "production"
      ? this.props.template.isExample()
        ? "/wp-content/plugins/wpmailer/screenshots"
        : "/wp-content/uploads/wpmailer"
      : this.props.template.isExample()
      ? "http://wewp-plugins.com/wp-content/plugins/wpmailer/screenshots"
      : "http://wewp-plugins.com/wp-content/uploads/wpmailer";
  @observable loading: boolean = false;

  @action onLoading = (isLoading: boolean) => {
    this.loading = isLoading;
  };

  render() {
    return (
      <TemplateStyled key={this.props.template.id} loading={this.loading}>
        <PreviewTemplateWrapper>
          <img
            src={`${this.BASE_URL}/${this.props.template.screenshot_path}`}
            alt={`Template screenshot - missing ${this.props.template.name} screenshot.`}
          />
        </PreviewTemplateWrapper>
        <CardTemplateActions {...this.props} onLoading={this.onLoading} />
      </TemplateStyled>
    );
  }
}

export default Template;
